import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { FormArray, FormGroup } from '@angular/forms';

import { ValuesService } from '@app/common/values/values.service';
import * as common from '@app/shared/_models/common';

import * as constants from "@app/shared/constants";
import { environment } from '../../../environments/environment';
import { Observable, throwError, EMPTY, of, concat } from 'rxjs';
import { map, switchMap, take } from 'rxjs/operators';
import { LoginService } from '@app/common/login.service';

interface OEmbedResponse {
  title: string;
  author_name: string;
  thumbnail_url: string;
}

@Injectable({
	providedIn: 'root'
})
export class AttachService {


	constructor(private http: HttpClient, public loginService: LoginService ) {}

	

    // documents image service
	public postAttach$(file : File, data: any,   objecttyp: number, objectid: number, ): Observable<any> {
    console.log('Salut from : inside common service postdoc value of file ',file);
    if (!file) { return throwError(() => new Error('Aucun fichier fourni') )}

    let fileName = file.name;
    let fileType = file.type; // ✅ Content-Type natif (ex: "application/pdf", "image/png")
    console.log('File type:', fileType); // Ex: "application/pdf"
    const formData: FormData = new FormData();
    formData.append("file", file);
		//formData.append("numIdentFact", this.numIdentFact);
		//formData.append("typepj", "PDF");  
		//formData.append("nature", "ORDN");
		const jsonBlob = new Blob([JSON.stringify({  name: fileName, userid:this.loginService.loggeduser?.id, objecttyp:objecttyp, objectid: objectid, data:data, contenttype:fileType , memo: "" })], { type: "application/json" });	// Wrap the JSON value in a Blob set to application/json
		formData.append("json", jsonBlob);
		console.log('formData',formData);

		return this.http.post<void>(environment.server_url + "/attach/upload", formData);
	}

  getYoutubeVideoInfo(videoUrl: string): Observable<any> {
    const oembedUrl = `https://www.youtube.com/oembed?url=${encodeURIComponent(videoUrl)}&format=json&maxwidth=900`;
    return this.http.get(oembedUrl);
  }

  public postYoutubeVideo$( data: any,   objecttyp: number, objectid: number, ){
		return this.http.post<void>(environment.server_url + "/attach/youtube/upload", {  name: data.title, userid:this.loginService.loggeduser?.id, objecttyp:objecttyp, objectid: objectid, data:data,contenttype:"video/youtube",  memo: "" });
  }


	

  public renameAttach$ (attach : common.Attach) :  Observable<any> {
		let event: common.Event = {
			id: 0,
			typ: constants.EventType.ATTACH_RENAME,			// 602 : Rename an attach of an object
			userid: this.loginService.loggeduser?.id,
			objectid: attach.id,
			objecttyp: constants.ObjectType.ATTACHEMENT,
			data: { name: attach.name },
		}
		return this.http.post<any>(environment.server_url + "/event", event, { 'headers': constants.jsonheader });
	}

  // 603 : upsert le mémo texte d'un attach (default_memo). Cible l'attach, pas la livraison => OK même sur un BL signé (cf. ATTACH_RENAME)
  public saveMemo$ (attach : common.Attach) :  Observable<any> {
		let event: common.Event = {
			id: 0,
			typ: constants.EventType.ATTACH_SAVE_MEMO,
			userid: this.loginService.loggeduser?.id,
			objectid: attach.id ?? 0,										// 0 => création côté back
			objecttyp: constants.ObjectType.ATTACHEMENT,
			data: {
				memo: attach.memo,
				parent_objecttyp: attach.objecttyp,						// DELIVERY (pour la création)
				parent_objectid: attach.objectid,						// id livraison
				flags: ['is_default_memo'],
			},
		}
		return this.http.post<any>(environment.server_url + "/event", event, { 'headers': constants.jsonheader });
	}

  public suppressImage(attach : common.Attach) :  Observable<any> {
		let event: common.Event = {
			id: 0,
			typ: constants.EventType.DELETE,			// 3: Delete
			userid: this.loginService.loggeduser?.id,
			objectid: attach.id,
			objecttyp: constants.ObjectType.ATTACHEMENT,
			data: {},
		}
		return this.http.post<any>(environment.server_url + "/event", event, { 'headers': constants.jsonheader });
	}


  public loadThumbnailImage$ ( attach : common.Attach  ) {
    if (!attach) return EMPTY;
    if( attach && attach.data && attach.data['thumbnail_url'] ){
      return this.http.get(  attach.data['thumbnail_url'] , { 
        responseType: 'blob' 
      });
    } else if ( attach.id) {
      return this.http.get( environment.server_url + '/attach/thumbnail/'+ attach.id , { 
      responseType: 'blob'
       });
    }
    return EMPTY;
   }

   
  public loadImage$ (id : number) {
    if (!id) return EMPTY;
   return this.http.get(  environment.server_url +  '/attach/content/'+id, { 
    // return this.http.get('http://localhost:5000/attach/content/16543516843513', {  // pour faire claquer une erreur et tester le cas de la requette qui ne foncitonne pas
      responseType: 'blob' 
    });
  }

  /**
   * Opens an attachment in a new browser tab securely via an authenticated Blob request.
   *
   * Opens a blank window synchronously on user click to prevent popup blockers,
   * then redirects it to the temporary Blob Object URL once received.
   *
   * @param id The attachment ID in `c_attach`.
   */
  public openInNewTab(id: number): void {
    if (!id || id <= 0) return;

    const win = window.open('', '_blank');
    if (win) {
      try {
        win.document.open();
        win.document.write('<!DOCTYPE html><html><head><title>Chargement du document…</title><style>html{background:#525659}body{margin:0;height:100vh;display:flex;align-items:center;justify-content:center;font-family:Roboto,Arial,sans-serif;color:#e8eaed;font-size:14px;}</style></head><body>Chargement du document…</body></html>');
        win.document.close();
      } catch {
        // Ignoré en cas de restriction de sécurité
      }
    }

    this.loadImage$(id).subscribe({
      next: (blob: Blob) => {
        const fileBlob = blob.type ? blob : new Blob([blob], { type: 'application/pdf' });
        const fileUrl = URL.createObjectURL(fileBlob);
        if (win && !win.closed) {
          win.location.href = fileUrl;
        } else {
          window.open(fileUrl, '_blank');
        }
        setTimeout(() => URL.revokeObjectURL(fileUrl), 60000);
      },
      error: (err) => {
        if (win && !win.closed) {
          win.close();
        }
        console.error('Erreur lors de l\'ouverture du document:', err);
      }
    });
  }
  
  public setDefaultImage$ (new_default_image: common.Attach, old_default_image: common.Attach| undefined  , is_selected :boolean) :  Observable<any> {
		let event: common.Event = {
			id: 0,
			typ: constants.EventType.ATTACH_SET_DEFAULT_IMG,			
			userid: this.loginService.loggeduser?.id,
			objectid: new_default_image.id, 
			objecttyp: constants.ObjectType.ATTACHEMENT,
			data: {   old_attach_id: ( old_default_image ? old_default_image.id : 0 ), // pas utilisé en back si besoin en feedback sur event
                new_attach_id :  new_default_image.id, // pas utilisé en back si besoin en feedback sur event
                flag: "is_default_image", // actuellement pas utilisé mais en back on peut facilement généralisé l'endpoint a plus de flags si besoin
                is_selected : is_selected, // utilisé
      },
		}
		return this.http.post<any>(environment.server_url + "/event", event, { 'headers': constants.jsonheader });

  }






  public postAttachAction(aa:any): Observable<any> {   // aa for attach action
    const headers = { 'content-type': 'application/json' };
    return this.http.post<any>(environment.server_url + "/attachaction", aa, { 'headers': headers });
  }

  // ─── Logique centralisée des attachs ───

  /** Filtre media (image, application, video) */
  private isMedia(a: common.Attach): boolean {
    return !!a.contenttype && (a.contenttype.startsWith('image') || a.contenttype.startsWith('application') || a.contenttype.startsWith('video'));
  }

  /**
   * Synchronise les attachs du serveur avec le tableau local d'images.
   * - Matche les placeholders (id=0) avec les nouveaux attachs par nom (spinner → image réelle)
   * - Ajoute les attachs media manquants
   * - Charge les thumbnails manquantes
   */
  // syncAttachImages(serverAttachs: common.Attach[], localAttachs: common.Attach[]): void {
  //   const mediaAttachs = serverAttachs.filter(a => this.isMedia(a) && a.id);
  //   // Matcher les placeholders (id=0, même nom) avec les attachs fraîchement créés côté serveur
  //   for (const newAttach of mediaAttachs) {
  //     console.log('Salut from : bbbbbbbbbbbbbbbbbbbbbbbb');
  //     console.log('newAttach',newAttach);
  //     const idx = localAttachs.findIndex(a => a.id === 0 && a.name === newAttach.name);
  //     console.log('idx',idx);
  //     if (idx !== -1) {
  //       localAttachs[idx] = { ...newAttach };
  //     }
  //   }

  //   // Ajouter les attachs pas encore présents dans le tableau local
  //   const toAdd = mediaAttachs.filter(a => !localAttachs.find(local => local.id === a.id));
  //   localAttachs.push(...toAdd);

  //   // Charger les thumbnails manquantes
  //   localAttachs.forEach((attach, index) => {
  //     if (attach.thumbnailLocalUrl) return;
  //     const sub = this.loadThumbnailImage$(attach.id ?? 0).subscribe(blob => {
  //       localAttachs[index].thumbnailLocalUrl = URL.createObjectURL(blob);
  //       sub.unsubscribe();
  //     });
  //   });
  // }

  generate_attachs_object_with_thumbnail (serverAttachs: common.Attach[] ): common.Attach[] {
    const mediaAttachs = [...serverAttachs.filter(a => this.isMedia(a) && a.id)];
    console.log('retunedAttachs',mediaAttachs);
    // Charger les thumbnails 
    mediaAttachs.forEach((attach, index) => {
      if (attach.thumbnailLocalUrl) return;
      this.loadThumbnailImage$(attach)
      .pipe(take(1)) // On ne prend que la première valeur et on complète
      .subscribe(blob => {
        mediaAttachs[index].thumbnailLocalUrl = URL.createObjectURL(blob);
      });
    });
    return mediaAttachs
  }

  /**
   * S'assure qu'un attach default_memo existe dans le FormArray.
   * C'est le mémo texte (textarea) rattaché à l'objet.
   */
  // ensureDefaultMemo(lnkAttachsFormArray: FormArray, attachsList: common.Attach[], objecttyp: number, objectid: number): void {
  //   const hasMemo = attachsList.find(a => a.data?.['flags']?.includes('is_default_memo'));
  //   if (!hasMemo) {
  //     lnkAttachsFormArray.push(common.Attach.asFormGroup({
  //       name: 'default_memo', memo: '', objecttyp, objectid,
  //       userid: this.loginService.loggeduser?.id ?? 0, datcre: new Date(),
  //       data: { flags: ['is_default_memo'] }, contenttype: 'text/html'
  //     } as common.Attach));
  //   }
  // }
    ensureDefaultMemo(lnkAttachsFormArray: FormArray,  objecttyp: number, objectid: number): void {
    const hasMemo = lnkAttachsFormArray.value.find((a: any) => a.data?.['flags']?.includes('is_default_memo'));
    if (!hasMemo) {
      lnkAttachsFormArray.push(common.Attach.asFormGroup({
        name: 'default_memo', memo: '', objecttyp, objectid,
        userid: this.loginService.loggeduser?.id ?? 0, datcre: new Date(),
        data: { flags: ['is_default_memo'] }, contenttype: 'text/html'
      } as common.Attach));
    }
  }

  getDefaultMemo(objecttyp: number, objectid: number): FormGroup {
    return common.Attach.asFormGroup({
      name: 'default_memo',  memo: '',  objecttyp,  objectid,
      userid: this.loginService.loggeduser?.id ?? 0, 
      datcre: new Date(), data: { flags: ['is_default_memo'] },  contenttype: 'text/html'
    } as common.Attach);
  }

  /**
   * Upload un fichier avec placeholder optimiste (spinner pendant l'upload).
   * Le composant appelant n'a plus qu'à subscribe et reload.
   */
  // uploadFileWithPlaceholder$(file: File, objecttyp: number, objectid: number, localAttachs: common.Attach[]): Observable<any> {
  //   localAttachs.push(new common.Attach({
  //     id: 0, userid: this.loginService.loggeduser?.id ?? 0,
  //     objecttyp, objectid, name: file.name,
  //     seq: localAttachs.length > 1 ? Math.max(...localAttachs.map(a => a.seq ?? 0)) + 1 : 1
  //   }));
  //   return this.postAttach$(file, null, objecttyp, objectid);
  // }
  uploadMediaWithPlaceholder$(file: File  , objecttyp: number, objectid: number, localAttachs: common.Attach[]): Observable<any> {
    // 1. On prépare l'objet temporaire (le placeholder)
    const new_attach = new common.Attach({
      id: 0, 
      userid: this.loginService.loggeduser?.id ?? 0,
      objecttyp, 
      objectid, 
      name: file.name,
      seq: localAttachs.length > 0 ? Math.max(...localAttachs.map(a => a.seq ?? 0)) + 1 : 1
    });

    // 2. On crée l'observable immédiat
    const immediateEmission$ = of({ 
      status: 'placeholder', 
      item: new_attach 
    });

    // 3. On crée l'observable de l'API (qui arrivera plus tard)
    const apiEmission$ = this.postAttach$(file, null, objecttyp, objectid).pipe(
      map(response =>  { 


        console.log('Salut from : oooooooooooooooooo');
        console.log('response',response);
        if (response && response.data && response.data.id) {

          new_attach.id = response.data.id;
        }
        return {
          status: 'completed', 
          item: new_attach, 
        }
      })
    );

    // 4. On concatène les deux : le premier émet de suite, le second attend le HTTP
    return concat(immediateEmission$, apiEmission$);

  }

  /**
   * Upload une vidéo YouTube avec placeholder optimiste.
   * Le composant appelant n'a plus qu'à subscribe et reload.
   */
  /**
   * Upload YouTube : même pattern placeholder/completed que uploadMediaWithPlaceholder$.
   * 1. Appel oEmbed pour récupérer le titre → émet {status:'placeholder', item}
   * 2. POST vers le back → émet {status:'completed', item} avec l'id serveur
   */
  uploadYoutubeWithPlaceholder$(youtubeUrl: string, objecttyp: number, objectid: number, localAttachs: common.Attach[]): Observable<any> {
    return this.getYoutubeVideoInfo(youtubeUrl).pipe(
      switchMap((videoInfo: any) => {
        videoInfo.url = youtubeUrl;

        const new_attach = new common.Attach({
          id: 0,
          userid: this.loginService.loggeduser?.id ?? 0,
          objecttyp, objectid,
          name: videoInfo.title,
          contenttype: 'video/youtube',
          data: { thumbnail_url: videoInfo.thumbnail_url, url: youtubeUrl },
          seq: localAttachs.length > 0 ? Math.max(...localAttachs.map(a => a.seq ?? 0)) + 1 : 1
        });

        const immediateEmission$ = of({ status: 'placeholder', item: new_attach });

        const apiEmission$ = this.postYoutubeVideo$(videoInfo, objecttyp, objectid).pipe(
          map((response: any) => {
            if (response?.data?.id) { new_attach.id = response.data.id; }
            return { status: 'completed', item: new_attach };
          })
        );

        return concat(immediateEmission$, apiEmission$);
      })
    );
  }







}
